import { useLanguage } from '../context/LanguageContext';
import { translations } from '../i18n/translations';

export const useT = () => {
  const { lang } = useLanguage();
  return translations[lang];
};
